import { render, staticRenderFns } from "./StyleSelect.vue?vue&type=template&id=836f041e"
import script from "./StyleSelect.vue?vue&type=script&lang=js"
export * from "./StyleSelect.vue?vue&type=script&lang=js"
import style0 from "./StyleSelect.vue?vue&type=style&index=0&id=836f041e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports